class SecDep {
  static check = (e) => {
    return new Promise((resolve) => {
      if(window.pd_sec_dependency) {
        window.pd_sec_dependency.forEach((secDep) => {
          let p = [];
          let s = document.querySelector(".drform ." + secDep.secondary);
          switch(secDep.condition.type) {
            case "visible":
              p = document.querySelector(".drform ." + secDep.primary);
              if(p.classList.contains("hidden")) {
                if(s && !s.classList.contains("hidden")){
                  s.classList.add("hidden");
                }
              } else {
                let pv = document.querySelector(".drform ." + secDep.primary + " .sc-dropdown__single-value");
                if(pv) {
                  let pvv = pv.innerHTML;
                  let con = secDep.condition.primaryValues
                    .map((m) => m.trim().toLowerCase())
                    .includes(pvv.trim().toLowerCase());
                  if(con) {
                    // Show secondary
                    if(s && s.classList.contains("hidden")){
                      s.classList.remove("hidden");
                    }
                  } else {
                    if(s && !s.classList.contains("hidden")){
                      s.classList.add("hidden");
                    }
                  }                 
                } else {
                  // not found hide secondary
                  if(s && !s.classList.contains("hidden")){
                    s.classList.add("hidden");
                  }                 
                }
              }
              break;
            case "simple-visible":
              p = document.querySelector(".drform ." + secDep.primary);
              if(p.classList.contains("hidden")) {
                if(s && !s.classList.contains("hidden")){
                  s.classList.add("hidden");
                }
              } else {
                if(s && s.classList.contains("hidden")){
                  s.classList.remove("hidden");
                }
              }
              break;
            case "complex_hide_when_not":
              // primary is a collection
              let isFound = false;
              secDep.primary.forEach((sdp,i) => { 
                p = document.querySelector(".drform ." + sdp + " .sc-dropdown__single-value");
                if(p) {
                  let pov = p.innerHTML;
                  let con = secDep.condition.primaryValues[sdp]
                    .map((m) => m.trim().toLowerCase())
                    .includes(pov.trim().toLowerCase());
                  if(con) {
                    isFound = true;
                  }
                }
              });
              if (!isFound && s && !s.classList.contains("hidden")) {
                s.classList.add("hidden");
              }
              break;
              case "hide-all":
                p = document.querySelector(".drform ." + secDep.primary);
                let pv = document.querySelector(".drform ." + secDep.primary + " .sc-dropdown__single-value");
                if(p.id.substring(1) === e.name.substring(1)) {
                  if(pv) {
                    let pvv = pv.innerHTML;
                    let con = secDep.condition.primaryValues
                      .map((m) => m.trim().toLowerCase())
                      .includes(pvv.trim().toLowerCase());
                    if(con) {
                      secDep.secondaryList.forEach((sl) => {
                        let hideEl = document.querySelector(".drform ." + sl);
                        if(sl === "submit") {
                          hideEl = document.querySelector('.drform button[type="submit"]');
                        }
                        if(hideEl) {
                          if(!hideEl.classList.contains("hidden")) {
                            hideEl.classList.add("hidden");
                            hideEl.classList.add("hb_" + secDep.primary);
                          }
                        }
                      });
                    } else {  //we don't have any secondary selected. so hide link
                      let btn = document.querySelector(".drform div.link-btn");
                      if(btn && !btn.classList.contains("hidden") && btn.classList.contains("sb_" + secDep.primary)) {
                        btn.classList.add('hidden');
                        btn.classList.remove("sb_" + secDep.primary)
                      }
                      secDep.secondaryList.forEach((sl) => {
                        let hideEl = document.querySelector(".drform ." + sl);
                        if(sl === "submit") {
                          hideEl = document.querySelector('.drform button[type="submit"]');
                        }
                        if(hideEl) {
                          if(hideEl.classList.contains("hidden") && hideEl.classList.contains("hb_" + secDep.primary)) {
                            hideEl.classList.remove("hidden");
                            hideEl.classList.remove("hb_" + secDep.primary);
                          }
                        }
                      });                      
                    }
                  }
                } else {
                  // Not in list -- is it hidden 
                  if(p.classList.contains("hidden")) {
                    let btn = document.querySelector(".drform div.link-btn");
                    if(btn && !btn.classList.contains("hidden") && btn.classList.contains("sb_" + secDep.primary)) {
                      btn.classList.add('hidden');
                      btn.classList.remove('sb_' + secDep.primary);
                    }
                    secDep.secondaryList.forEach((sl) => {
                      let hideEl = document.querySelector(".drform ." + sl);
                      if(sl === "submit") {
                        hideEl = document.querySelector('.drform button[type="submit"]');
                      }
                      if(hideEl) {
                        if(hideEl.classList.contains("hidden") && hideEl.classList.contains("hb_" + secDep.primary)) {
                          hideEl.classList.remove("hidden");
                          hideEl.classList.remove("hb_" + secDep.primary);
                        }
                      }
                    });                      
                  }
                }
              break;
            case "link-btn": 
              p = document.querySelector(".drform ." + secDep.primary);
              let pvl = document.querySelector(".drform ." + secDep.primary + " .sc-dropdown__single-value");
              if(pvl && p && !p.classList.contains("hidden")) {
                let pvv = pvl.innerHTML;
                let con = secDep.condition.primaryValues
                  .map((m) => m.trim().toLowerCase())
                  .includes(pvv.trim().toLowerCase());
                if(con) {
                  let btn = document.querySelector(".drform div.link-btn");
                  if(btn){
                    let btna = btn.querySelector("a");
                    if(btn.classList.contains("hidden")) {
                      btn.classList.remove("hidden");
                      btn.classList.add("sb_" + secDep.primary)
                    }
                    if (secDep.btn.action === "redirect") {
                      btna.href = secDep.btn.link;
                      btna.innerHTML = secDep.btn.text;
                      btna.onclick = (e) => {
                        e.preventDefault();
                        let dm = {
                          action: "pi-redirect",
                          rdlink: secDep.btn.link
                        }
                        window.parent.postMessage(dm,"*");
                      };
                    } else if (secDep.btn.action === "new-tab") {
                      btna.href = secDep.btn.link;
                      btna.innerHTML = secDep.btn.text;
                      btna.target = "_blank";
                    } else if (secDep.btn.action === "modal-redirect") {
                      btna.href = secDep.btn.link;
                      btna.innerHTML = secDep.btn.text;
                      btna.onclick = (e) => {
                        e.preventDefault();
                        let dm = {
                          action: "pi-modal-redirect",
                          rdlink: secDep.btn.link,
                          rmsg: secDep.btn.msg,
                          rbtntxt: secDep.btn.btntext,
                          rtime: secDep.btn.time
                        }
                        window.parent.postMessage(dm,"*");
                      };
                    }
                  }
                }
              }
              break;
            default: 
              //do nothing.
          }
        });
      }
      //Check link btns
      let btns = document.querySelectorAll(".drform div.link-btn");
      btns.forEach((btn) => {
        if(btn){
          if(!btn.classList.contains("hidden")) {
            let co = [...btn.classList].map((m) => {
              return m.startsWith('sb_') ? m.substring(3,m.length) : "";
            }).filter((f) => {
              return f.length > 0;
            });
            // Any not hidden.
            let nonHiddenObjs = co.filter((clname) => {
              let o = document.querySelector("." + clname);
              return o && !o.classList.contains("hidden");
            });
            if(nonHiddenObjs.length === 0) {
              btn.classList.add("hidden");
              co.forEach((clname) => {
                btn.classList.remove("sb_" + clname);
              });
            }
          }
        }
      });
      resolve("done");
    } );
  }
}

export {SecDep};
